import React from 'react';
import { Dialog, IconButton, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import workTimeTrackerImage1 from '../../../utilities/images/WorkTimeTracker/WorkTimeTrackerDialog1.jpg';
import workTimeTrackerImage2 from '../../../utilities/images/WorkTimeTracker/WorkTimeTrackerDialog2.jpg';
import workTimeTrackerImage3 from '../../../utilities/images/WorkTimeTracker/WorkTimeTrackerDialog3.jpg';
import ImageCarousel from './ImageCarousel';
import './Projects.css';
import { t } from 'i18next';
import SlideUpTransition from '../SlideUpTransition';
import ProjectActionButtons from './ProjectActionButtons';

interface WorkTimeTrackerDialogProps {
    open: boolean;
    onClose: () => void;
}

const WorkTimeTrackerDialog: React.FC<WorkTimeTrackerDialogProps> = ({ open, onClose }) => {
    const isCompactScreen = useMediaQuery('(max-width: 768px)');

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={isCompactScreen}
            TransitionComponent={SlideUpTransition}
            sx={{
                '& .MuiDialog-paper': {
                    margin: isCompactScreen ? 0 : 2,
                    width: isCompactScreen ? '100vw' : 'auto',
                    maxWidth: isCompactScreen ? '100vw' : 'min(92vw, 960px)',
                    maxHeight: isCompactScreen ? '100dvh' : '95dvh',
                    borderRadius: isCompactScreen ? 0 : 3,
                    overflow: isCompactScreen ? 'auto' : 'hidden',
                },
            }}
        >
            <div className="card">
                <IconButton aria-label="Close dialog" onClick={onClose} className="dialog-close-button" size="small">
                    <CloseIcon fontSize="small" />
                </IconButton>
                
                <div className="title">{t("projectDialogs.workTimeTracker.title")}</div>
                
                <div className="card-content">
                    <ImageCarousel
                        images={[workTimeTrackerImage1, workTimeTrackerImage2, workTimeTrackerImage3]}
                        alt={t("projectDialogs.workTimeTracker.title")}
                    />
                    
                    <div className="description">
                        <div className="left-box">
                            {t("projectDialogs.workTimeTracker.description")}
                        </div>
                        
                        <div className="right-box">
                            <div>Flutter</div>
                            <div>Dart</div>
                            <div>Material UI</div>
                            <div>Firebase</div>
                            <div>Android</div>
                        </div>
                    </div>
                </div>
                
                <ProjectActionButtons googlePlayUrl="https://play.google.com/store/apps/details?id=com.yourdomain.worktimetracker" />
            </div>
        </Dialog>
    );
};

export default WorkTimeTrackerDialog;